export function handleClientError(error) {
    console.trace(`Error occurred: ${error}`);
}